import { render, staticRenderFns } from "./pre-buy-whitelist.vue?vue&type=template&id=29d1c058&scoped=true&"
import script from "./pre-buy-whitelist.vue?vue&type=script&lang=js&"
export * from "./pre-buy-whitelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d1c058",
  null
  
)

export default component.exports